export const PRIVACY_PAGE_PATH = "/privacy";

export const openPrivacyPage = () => {
  window.open(PRIVACY_PAGE_PATH, "_blank", "noopener,noreferrer");
};
